import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { useTranslation } from "react-i18next";
import { translationConstants } from "../../../constants";

const BaseTable = (props) => {
  const { t } = useTranslation();
  const [setColumnPreference] = useState([]);

  const setOnDrag = (result) => {
    const columnsOrder = result.map((column) => column.id);
    setColumnPreference(columnsOrder);
  };

  const paginationComponentOptions = {
    rangeSepratorText: t(translationConstants.rangeSeparatorText),
    rowsPerPageText: t(translationConstants.rowsPerPageText),
  };

  return (
    <div className="w-100 ReactDataTable">
      <DataTable
        columns={props.columns}
        data={props.items}
        striped={true}
        progressPending={props.items.length <= 0}
        highlightOnHover={true}
        pagination={true}
        paginationComponentOptions={paginationComponentOptions}
        responsive
        onColumnOrderChange={setOnDrag}
      />
    </div>
  );
};

export default BaseTable;
